var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAchmandate(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    id: "Approve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#ffffff",
    className: "color000000 svgShape"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M36.37 9.46H11.61a2.79 2.79 0 0 0-2.79 2.79v17A2.8 2.8 0 0 0 11.61 32h6.93a1.25 1.25 0 0 0 0-2.5h-6.93a.3.3 0 0 1-.29-.3V12.25a.29.29 0 0 1 .29-.29h24.76a.29.29 0 0 1 .3.29v17a.3.3 0 0 1-.3.3h-6.93a1.25 1.25 0 1 0 0 2.5h6.93a2.81 2.81 0 0 0 2.8-2.8v-17a2.8 2.8 0 0 0-2.8-2.79Z",
    fill: "#ffffff",
    className: "color000000 svgShape"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.36 29.56V33a1.25 1.25 0 0 0 2.5 0v-3.44a1.25 1.25 0 0 0-2.5 0zm8.33-13.72a1.25 1.25 0 0 0-1.77 0L22.53 22l-2.66-2.62a1.25 1.25 0 0 0-1.75 1.78l3.52 3.47a1.26 1.26 0 0 0 .88.36 1.29 1.29 0 0 0 .87-.35l7.26-7a1.25 1.25 0 0 0 .04-1.8z",
    fill: "#ffffff",
    className: "color000000 svgShape"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAchmandate);
export default __webpack_public_path__ + "static/media/achmandate.4600bc97d8e42595f4fb970373013a20.svg";
export { ForwardRef as ReactComponent };